import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import { FormikProps } from 'formik';

interface IFormikCheckbox {
  name: string;
  formik: FormikProps<any>;
}
export const FormikCheckbox = ({
  name,
  formik,
  ...rest
}: IFormikCheckbox & CheckboxProps) => {
  const formikProps = formik.getFieldProps(name);
  return <Checkbox {...rest} {...formikProps} checked={formikProps.value} />;
};
